import { useMemo } from 'react';

import { bindPromiseAction } from 'app-components/flux/core/actionHelpers';
// CORE
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { transactionsActions, transactionsSelectors } from 'app-components/flux/transactions';

// CUSTOM
import useQDialogs from 'components/QDialogs/useQDialogs';

import { useAppStore } from 'hooks/redux';
import { noop } from 'lodash';
import * as qdata from './core';

function useTxnActions(props = {}) {
  const { wrapperId = 'txn-actions', robotMode = false, callback = noop, messages } = props;
  const featureFlags = useSelector(featureFlagsSelectors.getFeatureFlags);
  const store = useAppStore();

  // static store to get this data at the time of action call, prevents unnecessary rerenders.

  const getTxnsByAccountId = () =>
    transactionsSelectors.getTransactionsByAccountId(store.getState(), {
      txnTypes: transactionsSelectors.TxnTypes.ALL,
    });

  const dispatch = useDispatch();
  const createTransaction = (payload, meta) =>
    bindPromiseAction(dispatch, transactionsActions.createTransaction)(payload, meta);

  const updateTransaction = (payload, meta) =>
    bindPromiseAction(dispatch, transactionsActions.updateTransaction)(payload, meta);

  const deleteTransaction = (payload, meta) =>
    bindPromiseAction(dispatch, transactionsActions.deleteTransaction)(payload, meta);

  const batchTransactions = (payload, meta) =>
    bindPromiseAction(dispatch, transactionsActions.batchTransactions)(payload, meta);

  const performTransactionAction = (payload, meta) =>
    bindPromiseAction(dispatch, transactionsActions.performTransactionAction)(payload, meta);

  const genericDispatch = (action) => dispatch(action);

  const { dialogAlert } = useQDialogs();

  const forwardProps = {
    wrapperId,
    robotMode,
    createTransaction,
    deleteTransaction,
    updateTransaction,
    batchTransactions,
    performTransactionAction,
    genericDispatch,
    featureFlags,
    dialogAlert,
    callback,
    messages,
  };

  const QDperformTransactionAction = (action) => {
    const txnsByAccountId = getTxnsByAccountId();
    qdata.performTransactionAction(action, { ...forwardProps, txnsByAccountId });
  };
  const QDunMatchTransaction = (txn) => {
    const txnsByAccountId = getTxnsByAccountId();
    qdata.unMatchTransaction(txn, { ...forwardProps, txnsByAccountId });
  };
  const QDmatchTransactions = (txns) => {
    const txnsByAccountId = getTxnsByAccountId();
    qdata.matchTransactions(txns, { ...forwardProps, txnsByAccountId });
  };
  const QDdeleteTransactions = (txns) => {
    const txnsByAccountId = getTxnsByAccountId();
    qdata.deleteTransactions(txns, { ...forwardProps, txnsByAccountId, state: store.getState() });
  };
  const QDsaveTransactions = (txns, resolve, reject) => {
    const txnsByAccountId = getTxnsByAccountId();
    qdata.saveTransactions(txns, {
      ...forwardProps,
      txnsByAccountId,
      resolve,
      reject,
    });
  };

  const returnVal = useMemo(
    () => ({
      saveTransactions: QDsaveTransactions,
      deleteTransactions: QDdeleteTransactions,
      matchTransactions: QDmatchTransactions,
      unMatchTransaction: QDunMatchTransaction,
      performTransactionAction: QDperformTransactionAction,
    }),
    [wrapperId, robotMode, callback, featureFlags], // eslint-disable-line react-hooks/exhaustive-deps
  ); // only new props and feature flags require new functions

  return returnVal;
}

useTxnActions.propTypes = {
  wrapperId: PropTypes.string,
};

export default useTxnActions;
